/**
 * Draw circle/pie diagrams.
 *
 * @module diagram
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

var diagramCache  = {},
    hasIndicators = false,
    parentContainer,
    colorSet,
    indicators,
    diagram;


/**
 * Prepare colors from color sources.
 *
 * @param {Array} colors - raw colors or sample elements for extracting colors
 *
 * @return {Object} prepared color set
 */
function prepareColors ( colors ) {
    var inUseColor = typeof colors[0] === 'string' ? colors[0] : getComputedStyle(colors[0]).backgroundColor,
        freeColor  = typeof colors[1] === 'string' ? colors[1] : getComputedStyle(colors[1]).backgroundColor,
        text       = typeof colors[2] === 'string' ? colors[2] : getComputedStyle(colors[2]).color;

    freeColor = freeColor.replace(/(?:0\.)?\d+/g, function ( matched ) { return Math.floor(matched * 1.2); });

    return {
        inUseSpace: inUseColor,
        freeSpace:  freeColor,
        text:       text
    };
}


module.exports = {
    /**
     * Instantiate new circle (pie) diagram.
     *
     * @param {Panel} parent - parent container
     * @param {Array} colors - colors for diagram
     */
    init: function ( parent, colors ) {
        parentContainer = parent;
        colorSet        = prepareColors(colors);
    },

    /**
     * Draw diagram for free/allocated space on disk, set computed styles.
     *
     * @param {Object} data - data to display
     */
    draw: function ( data ) {
        var $canvasBlock, $canvas, $percentBlock, $indicatorsBlock,
            $allocatedSpaceTitle, $freeSpaceTitle, $freeSpaceMark, $allocatedSpaceMark,
            context, driveSpaceValues, radius, totalSize, index;

        if ( data.size === diagramCache.fullSize && data.free === diagramCache.freeSize ) {
            return;
        }

        $canvasBlock     = document.createElement('div');
        $canvas          = document.createElement('canvas');
        $percentBlock    = $canvasBlock.cloneNode(false);
        context          = $canvas.getContext('2d');
        driveSpaceValues = [data.size - data.free, data.free];
        radius           = 0;
        totalSize        = 0;

        diagramCache.fullSize = data.size;
        diagramCache.freeSize = data.free;

        if ( !hasIndicators ) {
            $freeSpaceMark      = $canvasBlock.cloneNode(false);
            $allocatedSpaceMark = $canvasBlock.cloneNode(false);
            $indicatorsBlock    = $canvasBlock.cloneNode(false);

            $allocatedSpaceTitle = document.createTextNode(gettext('In use'));
            $freeSpaceTitle  = document.createTextNode(gettext('Free'));

            $indicatorsBlock.className    = 'indicatorsBlock';
            $allocatedSpaceMark.className = 'allocatedSpaceMark';
            $freeSpaceMark.className      = 'freeSpaceMark';

            $allocatedSpaceMark.style.backgroundColor = colorSet.inUseSpace;
            $freeSpaceMark.style.backgroundColor      = colorSet.freeSpace;

            $indicatorsBlock.appendChild($allocatedSpaceMark);
            $indicatorsBlock.appendChild($allocatedSpaceTitle);
            $indicatorsBlock.appendChild($freeSpaceMark);
            $indicatorsBlock.appendChild($freeSpaceTitle);

            parentContainer.$body.children[0].appendChild($indicatorsBlock);

            hasIndicators = true;
        }

        if ( diagram ) {
            $canvasBlock.parentNode.removeChild(diagram);
            diagram = null;
        }

        $canvasBlock.className = 'infoStorageDiagram';

        $percentBlock.innerText   = Math.floor((data.size - data.free) * 100 / data.size) + '%';
        $percentBlock.style.color = colorSet.text;

        $canvasBlock.appendChild($canvas);
        $canvasBlock.appendChild($percentBlock);
        parentContainer.$body.children[0].appendChild($canvasBlock);

        for ( index = 0; index < driveSpaceValues.length; index += 1 ) {
            totalSize += driveSpaceValues[index];
        }

        $canvas.width = $canvas.height = parentContainer.$node.offsetHeight / 2.55;

        for ( index = 0; index < driveSpaceValues.length; index += 1 ) {
            context.fillStyle = [colorSet.inUseSpace, colorSet.freeSpace][index];
            context.beginPath();
            context.moveTo($canvas.width / 2, $canvas.height / 2);
            context.arc(
                $canvas.width / 2,
                $canvas.height / 2,
                $canvas.height / 2,
                radius,
                radius + (Math.PI * 2 * (driveSpaceValues[index] / totalSize)),
                false
            );
            context.lineTo($canvas.width / 2, $canvas.height / 2);
            context.fill();
            radius += Math.PI * 2 * (driveSpaceValues[index] / totalSize);
        }

        diagram    = $canvasBlock;
        indicators = $indicatorsBlock;
    },

    show: function () {
        if ( hasIndicators ) {
            diagram.classList.remove('hidden');
            indicators.classList.remove('hidden');
        }
    },

    hide: function () {
        if ( hasIndicators ) {
            diagram.classList.add('hidden');
            indicators.classList.add('hidden');
        }
    }
};
